import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "../../layouts/DashboardLayout";
import "./WorkoutPlans.css";

import {
  getWorkoutPlans,
  deleteWorkoutPlan,
} from "../../services/workoutPlanService";

export default function WorkoutPlans() {
  const navigate = useNavigate();

  const [plans, setPlans] = useState([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    loadPlans();
  }, []);

  const loadPlans = async () => {
    try {
      const data = await getWorkoutPlans();
      setPlans(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this workout plan?",
    );

    if (!confirmDelete) return;

    try {
      await deleteWorkoutPlan(id);

      alert("Workout Plan Deleted Successfully");

      loadPlans();
    } catch (error) {
      console.error(error);
      alert("Failed to delete workout plan");
    }
  };

  const filteredPlans = plans.filter(
    (plan) =>
      plan.planName?.toLowerCase().includes(search.toLowerCase()) ||
      plan.goal?.toLowerCase().includes(search.toLowerCase()) ||
      plan.level?.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <DashboardLayout>
      <div className="workout-container">
        <div className="workout-header">
          <div>
            <h1>Workout Plans</h1>

            <p>Create and manage workout plans for Premium members.</p>
          </div>

          <button
            className="add-plan-btn"
            onClick={() => navigate("/workout-plans/add")}
          >
            + Add Workout Plan
          </button>
        </div>

        <div className="search-box-container">
          <input
            type="text"
            placeholder="Search Workout Plan..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="table-wrapper">
          <table className="workout-table">
            <thead>
              <tr>
                <th>Plan Name</th>
                <th>Goal</th>
                <th>Level</th>
                <th>Monday</th>
                <th>Tuesday</th>
                <th>Wednesday</th>
                <th>Thursday</th>
                <th>Friday</th>
                <th>Saturday</th>
                <th>Sunday</th>
                <th>Actions</th>
              </tr>
            </thead>

            <tbody>
              {filteredPlans.length > 0 ? (
                filteredPlans.map((plan) => (
                  <tr key={plan.id}>
                    <td>{plan.planName}</td>

                    <td>{plan.goal}</td>

                    <td>{plan.level}</td>

                    <td>{plan.monday}</td>

                    <td>{plan.tuesday}</td>

                    <td>{plan.wednesday}</td>

                    <td>{plan.thursday}</td>

                    <td>{plan.friday}</td>

                    <td>{plan.saturday}</td>

                    <td>{plan.sunday}</td>

                    <td>
                      <button
                        className="edit-btn"
                        onClick={() =>
                          navigate(`/workout-plans/edit/${plan.id}`)
                        }
                      >
                        Edit
                      </button>

                      <button
                        className="delete-btn"
                        onClick={() => handleDelete(plan.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    No Workout Plans Found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
}
